module.exports = __webpack_public_path__ + "static/media/rajkhush-kumar.b1ea5bee.jpg";